var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SidebarNavItem',{attrs:{"classes":_vm.navItemClasses}},[_c('a',{staticClass:"nav-label",attrs:{"href":_vm.url}},[_c('AppIcon',{class:_vm.iconClasses,attrs:{"name":_vm.icon || 'circle',"inherit-size":""}}),_c('span',[_vm._v(_vm._s(_vm.name))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }